import Agent from "infrastructure/agent";
import authService from "services/auth.service";

export const getCurrentUser = () => Agent.get("/user/current");

const getAllAppRoles = () => Agent.get(`/user/approles`);

const createUserAppRoles = (userId, appRoles) =>
  Agent.post(`/user/${userId}/approles`, appRoles);

const openApiUrl = url =>
  authService
    .acquireTokenSilent([Agent.config.scope])
    .then(token =>
      window.open(
        `${Agent.config.apiRoot}${url}?access_token=${token}`,
        "_blank",
      ),
    );

export default {
  openApiUrl,
  getCurrentUser,
  getAllAppRoles,
  createUserAppRoles,
};
